import * as React from "react";
const SvgRenameFill = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, fill: "none", viewBox: "0 0 24 24", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M20 7a2 2 0 0 1 2 2v6a2 2 0 0 1-2 2h-3v3h2a1 1 0 1 1 0 2h-6a1 1 0 1 1 0-2h2v-3H4a2 2 0 0 1-2-2V9a2 2 0 0 1 2-2h11v10h2V7zm-7 4H6a1 1 0 1 0 0 2h7a1 1 0 1 0 0-2m6-9a1 1 0 1 1 0 2h-2v3h-2V4h-2a1 1 0 1 1 0-2z", clipRule: "evenodd" }));
export default SvgRenameFill;
